import $ from 'jquery';
import NoCity from 'portlets/site/order/nocity/nocity';
import NoDelivery from 'portlets/site/order/nodelivery/nodelivery';
import Info from 'portlets/site/order/info/info';
import Main from 'portlets/site/order/main/main';
import Analytics from 'modules/analytics/analytics';

export default class {
	constructor(options) {
		const defaults = {
			el: '#yotaOrder',
			dom: {
				nocity: '#yotaOrderNoCity',
				nodelivery: '#yotaOrderNoDelivery',
				main: '#yotaOrderMain',
				info: '#yotaOrderInfo'
			},
			classes: {
				nocity: 'b-order_state_nocity',
				nodelivery: 'b-order_state_nodelivery'
			}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = $(this.options.el);
		this.analytics = new Analytics();
		this.data = {};
		this.city = false;
		this.count = 1;
		this.$window = $(window);
		return this;
	}

	getDom() {
		this.$nocity = this.$el.find(this.options.dom.nocity);
		this.$nodelivery = this.$el.find(this.options.dom.nodelivery);
		this.$main = this.$el.find(this.options.dom.main);
		this.$info = this.$el.find(this.options.dom.info);
		return this;
	}

	onCitySet(data, from) {
		if (data != false) {
			this.city = data;
			this.$el.removeClass(this.options.classes.nocity);
			this.$el.toggleClass(this.options.classes.nodelivery, !data.deliveryAvailable);
			this.nodelivery.setCity(data);
			this.main.setCity(data);
		}

		if (from == 'init') {
			this.ga('init', data);
		} else {
			this.ga('setCity', data);
		}
	}

	onCountSet(count, /* from */) {
		this.main.setCount(count);
		if (this.count != count) {
			this.ga('setCount', count);
		}
		this.count = count;
	}

	onExpressSet(check, /* from */) {
		this.ga('setExpress', check);
	}

	onSmsSend(type, /* from */) {
		this.ga('sendSms', type);
	}

	render() {
		const self = this;
		if (self.$el.length) {
			if (yotaPortlets.order) {
				self.data = yotaPortlets.order;
			}

			self.getDom();
			self.nocity = new NoCity({
				el: self.$nocity,
				callback: {
					set: self.onCitySet.bind(self)
				}
			}).render();

			self.nodelivery = new NoDelivery({
				el: self.$nodelivery,
				callback: {
					set: self.onCitySet.bind(self)
				}
			}).render();

			self.main = new Main({
				el: self.$main,
				callback: {
					set: self.onCitySet.bind(self),
					express: self.onExpressSet.bind(self),
					sms: self.onSmsSend.bind(self)
				}
			}).render();

			self.info = new Info({
				el: self.$info,
				callback: {
					set: self.onCountSet.bind(self)
				}
			}).render();

			self.analytics.setData(self.data.analytics);

			self.onCitySet(self.data.data.city, 'init');
		}
		return self;
	}

	ga(type, data) {
		switch (type) {
			case 'setCity': {
				this.analytics.push({
					event: 'checkoutEvent#4',
					PRICE: this.info.getPrice(),
					QUANTITY: this.info.getCount(),
					'Город доставки': data.name
				});
				break;
			}

			case 'sendSms': {
				this.analytics.push({
					event: 'checkoutEvent#7',
					PRICE: this.info.getPrice(),
					QUANTITY: this.info.getCount(),
					'Город доставки': this.city.name,
					'Способ доставки': this.main.getExpress() ? 'Доставка за 90 минут' : 'Стандартная доставка'
				});
				break;
			}

			case 'setExpress': {
				this.analytics.push({
					event: 'checkoutEvent#6',
					PRICE: this.info.getPrice(),
					QUANTITY: this.info.getCount(),
					'Город доставки': this.city.name,
					'Способ доставки': data ? 'Доставка за 90 минут' : 'Стандартная доставка'
				});
				break;
			}

			case 'setCount': {
				this.analytics.push({
					event: 'checkoutEvent#5',
					PRICE: this.info.getPrice(),
					QUANTITY: data,
					'Город доставки': this.city.name
				});
				break;
			}

			case 'init': {
				if (data == false) {
					this.analytics.push({
						event: 'checkoutEvent#1',
						PRICE: this.info.getPrice(),
						QUANTITY: this.info.getCount()
					});
				} else {
					this.analytics.push({
						event: 'checkoutEvent#' + (data.deliveryAvailable ? '3' : '2'),
						PRICE: this.info.getPrice(),
						QUANTITY: this.info.getCount(),
						'Город доставки': data.name
					});
				}
				break;
			}
		}
	}
}



// WEBPACK FOOTER //
// ./app/portlets/site/order/order.js